import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-unsubscribe-reminder',
    templateUrl: './unsubscribe-reminder.component.html',
    styleUrls: ['./unsubscribe-reminder.component.scss'],
    standalone: false
})
export class UnsubscribeReminderComponent {
  middleContent: any;
  parameterobj: any;
  userToken: any;
  showThankyou: boolean=false;
  isUnsubscribed: boolean=false;
  currentRoute: string = '';
  constructor(
    private cmsService: CmsService,private activatedRoute:ActivatedRoute,public userInfoService:UserInfoService,
    private cdr:ChangeDetectorRef, protected config: OccConfig, private router: Router
  ) { 
     let url = this.router.url.split('/');
    this.currentRoute = url[url.length - 1];
  }

  ngAfterViewInit(){
    
    if (this.router.url.includes('marketingUnsubscribe')) {
      this.cmsService.getComponentData('unsubscribeMarketingComponent').subscribe(data => {
        this.middleContent = data;
        this.cdr.detectChanges();
      });
    } else {
      this.cmsService.getComponentData('unsubscribeParagraphComponent').subscribe(data => {
        this.middleContent = data;
        this.cdr.detectChanges();
      });
    }

    // this.cmsService.getComponentData('unsubscribeParagraphComponent').subscribe(data => {
    //   this.middleContent = data;
    //   this.cdr.detectChanges();
    // })
  }

  ngOnInit(){
    this.activatedRoute.queryParams.subscribe(res => { 
      this.parameterobj=res;
      this.userToken  = this.parameterobj.token;
      if(!this.router.url.includes('marketingUnsubscribe')){
      this.checkIfUnsubscribed(this.userToken)
      }
    });
    this.showThankyou =false;
  }

  checkIfUnsubscribed(userToken: any) {
    this.userInfoService.checkIfUnsubscribed(userToken).subscribe((data:any) => {
      this.isUnsubscribed=data;
    })
  }
  
  unsubscribeReminder(){
    if (!this.router.url.includes('marketingUnsubscribe')) {
      this.userInfoService.unsubscribeReminder(this.userToken).subscribe((data: any) => {
        this.showThankyou = true;
        this.cdr.detectChanges();
      });
    }else {
      this.userInfoService.marketingconsentuk(false,this.userToken).subscribe((data: any) => {
        this.showThankyou = true;
        this.cdr.detectChanges();
      });
    }
    // this.userInfoService.unsubscribeReminder(this.userToken).subscribe((data:any) => {
    //   this.showThankyou =true;
    //   this.cdr.detectChanges();
    // })
  }

}
